import React, { useState } from 'react';

import { LocationsMap } from './components/LocationsMap';
import { useAnimatedPins, usePins, useRegion } from './hooks';
import type { OrderStatusMapProps } from './types';
import { filterPropsByOrderType } from './utils';

// ────────────────────────────────────────────────────────────────────────────────

export const OrderStatusMap = (props: OrderStatusMapProps) => {
  const [selectedPin, setSelectedPin] = useState('');

  const filteredProps = filterPropsByOrderType(props);
  const pinCoordinates = useAnimatedPins(filteredProps);
  const animatedProps = { ...filteredProps, ...pinCoordinates };
  const region = useRegion(animatedProps);
  const pins = usePins(selectedPin, animatedProps);

  return (
    <LocationsMap region={region} pins={pins} onPinPress={setSelectedPin} />
  );
};
